import { render, staticRenderFns } from "./rewardUpdate.vue?vue&type=template&id=4c783108&scoped=true"
import script from "./rewardUpdate.vue?vue&type=script&lang=js"
export * from "./rewardUpdate.vue?vue&type=script&lang=js"
import style0 from "./rewardUpdate.vue?vue&type=style&index=0&id=4c783108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c783108",
  null
  
)

export default component.exports